<template>
    <div class="landing-body">
        <Header>
            <ul class="navbar-nav flex-row">
                <li class="nav-item">
                    <a class="nav-link" :href="routes.ABOUT_PRICING.url">Pricing</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" :href="routes.LOGIN.url">Sign In</a>
                </li>
            </ul>
        </Header>

        <CookieDlg v-if="needsCookieConsent" ref="cookieDlg"></CookieDlg>
        <main>
            <div class="section pt-3 pt-md-0 pb-3 pb-md-0" id="top">
                <div class="contents">
                    <div class="container-fluid h-100 p-0">
                        <div class="row m-0">
                            <div class="col-text col-sm-12 col-md-6  p-5 h-100">
                                <div>
                                <h1>Project Collaboration Service</h1>
                                <div class="help-text">For your desktop GanttProject app.</div>
                                </div>
                                <div class="flex-row">
                                    <i class="fa fa-globe-americas fa-2x fa-fw"></i>
                                    <div>
                                        <a class="flex-fill" href="#storage">Keep GanttProject documents always at hand.
                                            <br> Everywhere in the world.
                                            <br> Online and offline.</a>
                                        <br>
                                        <a class="btn btn-sm btn-learn-more" href="#storage">Learn more
                                            <i class="fa fa-fw fa-caret-down"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="flex-row">
                                    <i class="fa fa-sync fa-2x fa-fw"></i>
                                    <div>
                                        <a class="flex-fill" href="#collaboration">Update projects safely and keep them synced.</a>
                                        <br>
                                        <a class="btn btn-sm btn-learn-more" href="#collaboration">Learn more
                                            <i class="fa fa-fw fa-caret-down"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="flex-row">
                                    <i class="fa fa-users fa-2x fa-fw"></i>
                                    <div>
                                        <a class="flex-fill" href="#start-now">Build big teams and keep bills small.
                                        <br>Low cost, pay as you go pricing.</a>
                                        <br>
                                        <a class="btn btn-sm btn-learn-more" href="#start-now">Learn more
                                            <i class="fa fa-fw fa-caret-down"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6
                                d-flex flex-column align-items-center justify-content-center
                                h-100 col-image">
                                <div class="img-wrapper">
<!--                                    <div class="aligner"></div>-->
                                    <img :srcset="cdnUrl('/img/landing-img1-xs.jpg') + ' 432w,' +
                                    cdnUrl('/img/landing-img1-sm.jpg') + ' 576w,' +
                                    cdnUrl('/img/landing-img1-md.jpg') + ' 744w,' +
                                    cdnUrl('/img/landing-img1-lg.jpg') + ' 900w,' +
                                    cdnUrl('/img/landing-img1-xl.jpg') + ' 1200w,' +
                                    cdnUrl('/img/landing-img1.jpg') + ' 2160w'"
                                         sizes="(max-width: 576px)    432px,
                                    ((max-width: 768px) and (min-height: 500px))  576px,
                                    ((max-width: 1366px) and (min-height: 700px))      744px,
                                    (max-width: 1920px) and (min-height: 1000px))      900px,
                                    1200px"
                                         :src="cdnUrl('/img/landing-img1-lg.jpg')"
                                         class="img-fluid" alt="Cro-Magnons Team Work">
                                </div>

                                <div class="underimage mt-sm-3">
                                    <a role="button" class="btn btn-attention btn-lg" :href="routes.SIGNUP.url">Sign Up Now</a>
                                </div>
                                <!--<div class="img-shadow"></div>-->
                                <!--<div style="position: relative">-->
                                <!--</div>-->
                                <div class="scroll-down d-none d-md-flex justify-content-end">
                                    <a href="#storage" class="btn btn-link"><i class="fas fa-3x fa-arrow-alt-circle-down colors-primary"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section" id="storage">
                <div class="contents" id="page1">
                    <div class="container-fluid h-100 p-0">
                        <div class="row m-0">
                            <div class="col-sm-12 order-1
                                col-md-6  order-md-0
                                d-flex justify-content-center align-items-center
                                h-100 p-5 col-image">
                                <div class="img-wrapper">
<!--                                    <div class="aligner"></div>-->
                                    <img :srcset="cdnUrl('/img/landing-img2-xs.jpg') + ' 432w,' +
                                    cdnUrl('/img/landing-img2-sm.jpg') + ' 576w,' +
                                    cdnUrl('/img/landing-img2-md.jpg') + ' 744w,' +
                                    cdnUrl('/img/landing-img2-lg.jpg') + ' 900w,' +
                                    cdnUrl('/img/landing-img2-xl.jpg') + ' 1200w,' +
                                    cdnUrl('/img/landing-img2.jpg') + ' 2160w'"
                                         sizes="(max-width: 576px)    432px,
                                    ((max-width: 768px) and (min-height: 500px))  576px,
                                    ((max-width: 1366px) and (min-height: 700px))      744px,
                                    (max-width: 1920px) and (min-height: 1000px))      900px,
                                    1200px"
                                         :src="cdnUrl('/img/landing-img2-lg.jpg')"
                                         class="img-fluid" alt="Cro-Magnons Project History">
                                </div>
                            </div>
                            <div class="col-text col-sm-12 order-xs-0 order-sm-0
                                col-md-6  order-md-1
                                p-5 h-100">
                                <div class="scroll-up d-none d-md-flex justify-content-end">
                                    <a href="#top" class="btn btn-link fa-3x btn-top">
                                        <i class="colors-primary fas fa-arrow-alt-circle-up"></i>
                                    </a>
                                </div>
                                <h2>Cloud Storage</h2>
                                <div class="flex-row">
                                    <i class="fa fa-2x fa-fw fa-cloud-upload-alt"></i>
                                    <div>
                                        <div>Secure and Reliable</div>
                                        <div class="help-text">We store GanttProject files in a secure highly available Google Cloud Storage</div>
                                    </div>
                                </div>
                                <div class="flex-row">
                                    <i class="fa fa-2x fa-fw fa-laptop"></i>
                                    <div><div>Integrated with GanttProject Desktop</div>
                                        <div class="help-text">Files stored on GanttProject Cloud are available directly from the desktop GanttProject. Nearly zero configuration required.</div>
                                    </div>
                                </div>
                                <div class="flex-row">
                                    <i class="fa fa-2x fa-fw fa-download"></i>
                                    <div><div>Available Offline</div>
                                        <div class="help-text">You can make any project available offline at your local disk</div>
                                    </div>
                                </div>
                                <div class="scroll-down d-none d-md-flex justify-content-end">
                                    <a href="#collaboration" class="btn btn-link fa-3x btn-down">
                                        <i class="colors-primary fas fa-arrow-alt-circle-down"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section" id="collaboration">
                <div class="contents" id="page2">
                    <div class="container-fluid h-100 p-0">
                        <div class="row m-0">
                            <div class="col-text col-sm-12 col-md-6 p-5 h-100">
                                <h2>Work Collaboratively</h2>
                                <div class="flex-row">
                                    <i class="fa fa-2x fa-fw fa-shield-alt"></i>
                                    <div>
                                        <div>Easy Access Management</div>
                                        <div class="help-text">Create teams and add people to teams to grant them access to team project files</div>
                                    </div>
                                </div>
                                <div class="flex-row">
                                    <i class="fa fa-2x fa-fw fa-user-lock"></i>
                                    <div>
                                        <div>Safe Updates</div>
                                        <div class="help-text">Resolving concurrent modifications is hard. Use project locks to prevent project from being modified by anyone else.</div>
                                    </div>
                                </div>
                                <div class="flex-row">
                                    <i class="fa fa-2x fa-fw fa-bell"></i>
                                    <div>
                                        <div>Get Notifications</div>
                                        <div class="help-text">Stay tuned and receive notifications into desktop GanttProject when someone updates, locks or unlocks project</div>
                                    </div>
                                </div>
                                <div class="flex-row">
                                    <i class="fa fa-2x fa-fw fa-history"></i>
                                    <div>
                                        <div>Project History</div>
                                        <div class="help-text">We keep the history of recent project changes.
                                            Even in case of update clashes
                                            one can recover project from previous versions.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6
                                d-flex justify-content-center align-items-center
                                h-100 p-5 col-image">
                                <div class="scroll-up d-none d-md-flex justify-content-end">
                                    <a href="#top" class="btn btn-link fa-3x btn-top">
                                        <i class="colors-primary fas fa-arrow-alt-circle-up"></i>
                                    </a>
                                </div>
                                <div class="img-wrapper">
<!--                                    <div class="aligner"></div>-->
                                    <img :srcset="cdnUrl('/img/landing-img3-xs.jpg') + ' 432w,' +
                                    cdnUrl('/img/landing-img3-sm.jpg') + ' 576w,' +
                                    cdnUrl('/img/landing-img3-md.jpg') + ' 744w,' +
                                    cdnUrl('/img/landing-img3-lg.jpg') + ' 900w,' +
                                    cdnUrl('/img/landing-img3-xl.jpg') + ' 1200w,' +
                                    cdnUrl('/img/landing-img3.jpg') + ' 2160w'"
                                         sizes="(max-width: 576px)    432px,
                                    (max-width: 768px)      576px,
                                    (max-width: 1366px)      744px,
                                    (max-width: 1920px)      900px,
                                    1200px"
                                         :src="cdnUrl('/img/landing-img3-lg.jpg')"
                                         class="img-fluid" alt="Cro-Magnons happily completed their project">
                                </div>
                                <div class="scroll-down d-none d-md-flex justify-content-end">
                                    <a href="#start-now" class="btn btn-link fa-3x btn-down">
                                        <i class="colors-primary fas fa-arrow-alt-circle-down"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section" id="start-now">
                <div class="contents" id="page3">
                    <div class="container-fluid h-100 p-0">
                        <div class="row m-0">
                            <div class="col-image col-sm-12 col-md-6 p-5 h-100 justify-content-center">
                                <div class="d-flex justify-content-center" style="font-size: 130%">
                                    GanttProject Cloud is free to start.
                                </div>
                                <div class="d-flex justify-content-center m-5">
                                    <a role="button" class="btn btn-attention btn-lg" :href="routes.SIGNUP.url">Sign Up Now</a>
                                </div>
                                <div class="mt-2 d-flex justify-content-center text-center d-link">
                                    <a class="inline-link mr-2" :href="routes.ABOUT_PRICING.url">Learn more</a>&nbsp;about our pricing
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6
                                d-flex justify-content-center
                                h-100 p-5 col-image">
                                <div class="scroll-up d-none d-md-flex justify-content-end">
                                    <a href="#top" class="btn btn-link fa-3x btn-top">
                                        <i class="colors-primary fas fa-arrow-alt-circle-up"></i>
                                    </a>
                                </div>
                                <div class="row">
                                    <div class="col-6 col-footer">
                                        <h3>About</h3>
                                        <div><a class="inline-link" :href="routes.ABOUT_TOS.url">Terms of Service</a></div>
                                        <div><a class="inline-link" :href="routes.ABOUT_PRIVACY.url">Privacy Policy</a></div>
                                        <div><a class="inline-link" :href="routes.ABOUT_PRICING.url">Pricing</a></div>
                                        <div><a class="inline-link" :href="routes.ABOUT_TEAM.url">Our Team</a></div>
                                    </div>
                                    <div class="col-6 col-footer">
                                        <h3>Help Pages</h3>
                                        <div><a class="inline-link" href="https://help.ganttproject.biz/t/read-me-first-faq-and-search/8">FAQ</a></div>
                                        <div><a class="inline-link" href="https://help.ganttproject.biz">Support Forum</a></div>
                                        <div><a class="inline-link" href="https://github.com/barsoftware/ganttproject">Issue Tracker</a></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 col-footer">
                                        <h3>Follow Us</h3>
                                        <div><i class="fab fa-twitter-square"></i>&nbsp;<a class="inline-link" href="https://twitter.com/ganttcloud">Twitter</a></div>
                                        <div><i class="fab fa-facebook-square"></i>&nbsp;<a class="inline-link" href="https://www.facebook.com/ganttcloud">Facebook</a></div>
                                    </div>
                                    <div class="col-6 col-footer">
                                        <h3>See also</h3>
                                        <div><a class="inline-link" href="https://www.ganttproject.biz">GanttProject Desktop</a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <ErrorWidget ref="errorWidget"></ErrorWidget>
    </div>
</template>

<script lang="ts">
import Header from './components/Header.vue';
import CookieDlg from './components/CookieDlg.vue';
import {Component, Vue, toNative} from 'vue-facing-decorator';
import {AboutPricing, AboutPrivacy, AboutTeam, AboutTos, Signin, Signup} from './Routes';
import {installGoogleAnalytics} from './utils/Analytics';
import {setErrorWidget} from './utils/Ui';
import ErrorWidget from './components/ErrorWidget.vue';

import $ from 'jquery';

@Component({
    components: {ErrorWidget, Header, CookieDlg},
  })
  class Landing extends Vue {
    public readonly routes = {
      SIGNUP: Signup,
      ABOUT_PRICING: AboutPricing,
      ABOUT_TOS: AboutTos,
      ABOUT_PRIVACY: AboutPrivacy,
      ABOUT_TEAM: AboutTeam,
      LOGIN: Signin,
    };
    public readonly sectionOffsets: MutableList<SectionOffset> = [];
    public readonly needsCookieConsent: boolean = window.needsCookieConsent || false;
    public $refs!: {
      cookieDlg: CookieDlg
      errorWidget: ErrorWidget,
    };

    public mounted() {
      $('.section').each((_, domSection) => {
        this.sectionOffsets.push(new SectionOffset($(domSection)));
      });
      $('main').on('scroll', this.stickifySections);

      $('.scroll-up a').on('click', function(e) {
        $('main').scrollTop(0);
        window.location.hash = '';
        e.preventDefault();
      });
      window.onhashchange = () => {
        this.processHashChange(window.location.hash, undefined);
      };
      if (this.needsCookieConsent) {
        this.$refs.cookieDlg.show();
      }
      setErrorWidget(this.$refs.errorWidget);
    }
    private cdnUrl(path: string): string {
      return path;
    }

    private stickifySections = () => {
      this.sectionOffsets.map((sectionOffset, index) => {
        sectionOffset.setZIndex(index - this.sectionOffsets.length);
      });
    }

    // This function returns the top offset of the given section if
// all sections were laid out one after another, just like after page loading.
    private getStartScroll(hash: string): number {
      let scroll = 0;
      let stop = false;
      this.sectionOffsets.forEach((section) => {
        // Iterate all sections until we find the given one.
        // If section's offset is close to 9 (hello Edge! you have it 0.9)
        // then it is currently "sticky" and we add its height to the sum
        const sectionHash = `#${section.id}`;
        if (sectionHash === hash) {
          stop = true;
        } else {
          if (!stop && section.getOffsetTop() <= 1) {
            scroll += section.getHeight();
          }
        }
      });
      return scroll;
    }

    // This function is called when page hash changes.
// Hash change may trigger automatic scroll (this is the cae when we click
// one of the scroll-down buttons). However, it may not trigger scroll (e.g.
// when we click scroll-up or use browser history buttons), and in
// this case we have to scroll on our own.
// If scroll is triggered automatically then this function may be called either
// when page has already been scrolled to the target element or somewhere in the middle of
// scrolling.
// In the first case we don't want to do anything.
// In the second case we schedule another call of this function and do so until scrolling
// stops or we run out of attempts.
    private processHashChange(hash: string, prevOffset?: number, counter = 5) {
      const main = $('main');
      if (hash === '' || hash === '#' || hash === '#top') {
        main.scrollTop(0);
        return;
      }
      const hashOffset = $(hash).position();
      if (hashOffset.top <= 1) {
        // This element is already scrolled to the top of the page,
        // but chances are that it is sticky and hiding behind subsequent sections.
        const scroll = this.getStartScroll(hash);
        if (scroll !== main.scrollTop()) {
          main.scrollTop(scroll);
        }
      } else {
        // Section is somewhere far away. However, chances are that it is scrolling right now.
        // Let's compare its current offset with the previous one (if any) and if they
        // are the same then no, we're not scrolling. Otherwise try again in 50ms.
        if (prevOffset !== undefined && hashOffset.top === prevOffset) {
          main.scrollTop(this.getStartScroll(hash));
        } else {
          if (counter > 0) {
            window.setTimeout(this.processHashChange, 50, hash, hashOffset.top, counter - 1);
          }
        }
      }
    }
  }

  export default toNative(Landing);

class SectionOffset {
    public readonly contents: JQuery;
    public readonly id: string;

    constructor(readonly section: JQuery) {
        this.contents = this.section.find('.contents');
        this.id = section.attr('id');
    }

    public setZIndex(value: number) {
        this.contents.css('z-index', value);
    }

    public getOffsetTop(): number {
        return this.contents.position().top;
    }

    public getHeight(): number {
        return this.contents.height();
    }
}

installGoogleAnalytics();

// if (window["needsCookieConsent"]) {
//     window.setTimeout(function () {
//         const dlg = new CookieDlg();
//         dlg.show();
//     }, 100);
// }
</script>

<style scoped lang="scss">
@import "sass/components/landing-body.scss";
    .btn-learn-more {
        visibility: hidden;
        white-space: nowrap;
    }
    @media (max-height: 539px) {
        .col-text, .col-image {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
        }
        .col-text .flex-row {
            margin-top: 2ex;
        }
    }
    .section {
      height: auto;
      @include media-breakpoint-up(md) {
        @supports(position:sticky) {
          position: sticky;
        }
        height: 100%;
      }
      @media (max-height: 539px) {
        height: auto !important;
        position: relative;
      }
      background: $gp-main-background;
      color: $gp-dark-brand;
      position: relative;
      top: 0;
      width: 100%;
      z-index: 0;

      &:first-child {
        margin-top: 0;
      }

    }
    .contents {
      height: 100%;
      font-size: small;
    }
    .contents .flex-row:hover .btn-learn-more {
        visibility: visible;
    }
    @media (min-height: 768px) {
        .contents {
            font-size: medium;
        }
    }
    @media (min-height: 1024px) {
        .contents {
            font-size: large;
        }
    }
    .col-image {
      @include section-dark();
      @include font-size-xxl();

      @media (max-height: 699px) {
        padding: 5px;
      }
      //.aligner {
      //  display: inline-block;
      //  height: 100%;
      //  vertical-align: middle;
      //}
      .img-wrapper {
        width: 100%;
        //flex: 1;
        text-align: center;
        max-height: 80%;
      }
      img {
        max-height: 80%;
        @media (max-height: 699px) {
          max-width: 320px;
        }
        @media (min-height: 700px) and (max-height: 767px) {
          max-width: 386px;
        }
        @media (min-height: 768px) {
          max-width: 80%;
        }
        vertical-align: middle;
        padding: 10px 0px;
        border-top: solid $gp-light-brand 3px;
        border-bottom: solid $gp-light-brand 3px;
      }
      .scroll-down {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: auto;
        font-size: medium;
        pointer-events: none;
        & a {
          pointer-events: auto;
        }
      }
      .scroll-up {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: auto;
        font-size: medium;
        pointer-events: none;
        & a {
          pointer-events: auto;
        }
      }

      //.img-shadow {
      //  position: absolute;
      //  top: 0;
      //  left: 0;
      //  right: 0;
      //  bottom: 0;
      //  box-shadow: inset 3px 3px 10px 0 #424242;
      //  border-radius: 20px;
      //}
      .underimage {
        margin-bottom: 10px;
        z-index: 1;
      }
    }

    .landing-body {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
</style>
